import styled from '@emotion/styled';
import { TableCell, TableHead, TableRow } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const Wrapper = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: none;
  box-sizing: border-box;

  .MuiPagination-root {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding-top: 24px;
  }

  .MuiPaginationItem-root {
    color: ${customPalette.accent.main};

    &.Mui-selected {
      background-color: ${customPalette.accent.main};
      color: ${customPalette.accent.white};
    }
  }

  @media (max-width: 600px) {
    .table-wrapper {
      overflow-x: auto;
      scrollbar-width: thin;
      scrollbar-color: ${customPalette.accent.main}
        ${customPalette.accent.white};
    }

    .table-wrapper::-webkit-scrollbar {
      height: 8px;
    }

    .table-wrapper::-webkit-scrollbar-thumb {
      background-color: ${customPalette.accent.main};
      border-radius: 4px;
    }

    .table-wrapper::-webkit-scrollbar-track {
      background: ${customPalette.accent.white};
    }
  }

  .skeleton-table {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .skeleton-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }
`;

export const StyledTableCell = styled(TableCell)`
  border-bottom: none;
  padding: 16px 0;
  text-align: left;
  display: flex;
  align-items: center;

  &:nth-of-type(1) {
    flex: 1 1 50%;
  }

  &:nth-of-type(2) {
    flex: 1 1 15%;
  }

  &:nth-of-type(3) {
    flex: 1 1 20%;
  }

  &:nth-of-type(4) {
    flex: 1 1 15%;
  }
`;

export const StyledTableRow = styled(TableRow)`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  height: 60px;

  &:hover {
    background-color: ${customPalette.grey[0]};
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const StyledTableHead = styled(TableHead)`
  display: flex;
  padding-left: 5px;
  font-weight: 600;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  height: 60px;

  &:hover {
    background-color: ${customPalette.grey[0]};
  }
`;

export const StyledHeaderTableCell = styled(StyledTableCell)`
  font-weight: 600;
`;

export const DocumentLink = styled.span`
  cursor: pointer;
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const ViewAllWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
`;

export const StyledDownloadIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`;
